// extracted by mini-css-extract-plugin
module.exports = {"PodSmallRegularLayout":"Features_PodSmallRegularLayout__6EIot","PodSmallRegularBox":"Features_PodSmallRegularBox__xTdAj"};